import { render, staticRenderFns } from "./backSimulator.vue?vue&type=template&id=803d1d86&scoped=true"
import script from "./backSimulator.vue?vue&type=script&lang=js"
export * from "./backSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803d1d86",
  null
  
)

export default component.exports